
































import {Component, Vue} from 'vue-property-decorator';
import {mapGetters} from 'vuex';
import SideBarActions from '@/view/sidebar/store-module/utility';
import SideBarMenuItem from '@/view/sidebar/domain/SideBarMenuItem';
import {menuItems} from '@/view/sidebar/SideBarNavItems';

@Component({
    components: {},
    computed: {
        ...mapGetters(['getSideBarVisible']),
    },
})
export default class SideBarNav extends Vue {
    private menuItems: SideBarMenuItem[] = menuItems;
    private sideBarWidthDesktop: number = 170;
    private sideBarWidthMobile: number = 300;
    private mobileDesktopBreak: number = 600;
    private keepOpenWidth: number = 1000;
    private screenWidth: number = 0;
    private accordion: number = 0;

    get mobile(): boolean {
        return this.screenWidth <= this.mobileDesktopBreak;
    }

    get keepOpen(): boolean {
        return this.screenWidth > this.keepOpenWidth;
    }

    get sideBarWidth(): number {
        if (!this.mobile) {
            return this.sideBarWidthDesktop;
        }
        return this.sideBarWidthMobile;
    }

    get sideBarOpenCss(): any {
        return {
            width: this.sideBarWidth + 'px',
            left: 0,
        };
    }

    get sideBarCloseCss(): any {
        return {
            left: -this.sideBarWidth + 'px',
            transition: 'all 0.3s',
        };
    }

    get containerOpenCss(): any {
        if (!this.mobile) {
            return {
                width: 'calc(100% - ' + this.sideBarWidth + 'px) !important',
            };
        }
        return {};
    }

    private created() {
        this.$store.subscribe((mutation) => {
            if (mutation.type === SideBarActions.HIDE_SIDEBAR) {
                this.accordion = 0;
            }
        });
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
        if (this.keepOpen) {
            this.$store.commit(SideBarActions.SHOW_SIDEBAR);
        }
    }

    private destroyed() {
        window.removeEventListener('resize', this.handleResize);
    }

    private handleResize() {
        this.screenWidth = window.innerWidth;
        if (this.keepOpen) {
            this.$store.commit(SideBarActions.SHOW_SIDEBAR);
        } else {
            this.$store.commit(SideBarActions.HIDE_SIDEBAR);
        }
    }

    private toggleAccordion(value: number): void {
        if (value === this.accordion) {
            this.accordion = 0;
        } else {
            this.accordion = value;
        }
    }

    private hideSideBar(): void {
        this.$store.commit(SideBarActions.HIDE_SIDEBAR);
    }

    private navClick(route: string, value: number): void {
        this.toggleAccordion(value);
        this.$router.push({ name: route});
        if (this.mobile || !this.keepOpen) {
            this.$store.commit(SideBarActions.HIDE_SIDEBAR);
        }
    }

    private activeParentRoute(parent: SideBarMenuItem): boolean {
        if (parent.children) {
            for (const child of parent.children) {
                if (child.route === this.$route.name) {
                    return true;
                }
            }
        }
        return false;
    }
}
